import React from 'react';
type SectionHeadingProps = {
  eyebrow: string;
  title: React.ReactNode;
  description?: string;
  tone?: 'dark' | 'light';
  align?: 'left' | 'center';
};
export function SectionHeading({
  eyebrow,
  title,
  description,
  tone = 'dark',
  align = 'left'
}: SectionHeadingProps) {
  const isDark = tone === 'dark';
  return <div className={align === 'center' ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'} data-id="element-167" data-mp="3k0yi4c45t9at">
      <div className={`flex items-center gap-3 ${align === 'center' ? 'justify-center' : ''}`} data-id="element-168" data-mp="blerlkuvi4zg">
        <span className="h-[2px] w-8 bg-brand" aria-hidden="true" data-id="element-169" data-mp="gieytz3glds5" />
        <span className={`font-mono text-[11px] uppercase tracking-[0.28em] ${isDark ? 'text-brand-light' : 'text-brand'}`} data-id="element-170" data-mp="1utu60qxr6i4">
          {eyebrow}
        </span>
      </div>
      <h2 className={`mt-5 font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight sm:text-5xl ${isDark ? 'text-white' : 'text-steel-950'}`} data-id="element-171" data-mp="uipsf9w5l6h0">
        {title}
      </h2>
      {description && <p className={`mt-5 text-base leading-relaxed ${isDark ? 'text-steel-300' : 'text-steel-500'}`} data-id="element-172" data-mp="1ta8o5eqkkfnn">
          {description}
        </p>}
    </div>;
}